var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.usosCFDI,"item-text":"Descripcion","item-value":"IdUsoCFDI","label":"Selecciona Uso CFDI","clearable":"","outlined":"","dense":"","rules":[_vm.rules.ruleRequired]},on:{"change":_vm.onSelect},model:{value:(_vm.selectedUso),callback:function ($$v) {_vm.selectedUso=$$v},expression:"selectedUso"}})
}
var staticRenderFns = []

export { render, staticRenderFns }